export const state = {
    theme: '',
    lang: localStorage.getItem('lang') || 'en'
};